// extracted by mini-css-extract-plugin
export default {"groupWrapper":"WqT7o4"};